import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
  CognitoRefreshToken
} from 'amazon-cognito-identity-js';

import { constructUserCredentials } from '@/authentication/auth.js';

export default new Vuex.Store({
  state: {
    version:'v0.10b',
    drawer:false,
  	help:'',
    global_message:{
        show:true,
        message:'Welcome to Shutle',
        color:'success'
    },

  	uri: {

      app_base_uri:'https://studio.myshuttle.io',

    	//api_base_uri:'https://gateway.myshuttle.io/prod/',
      //api_base_uri:'https://gateway-dev.myshuttle.io/',
      api_base_uri:(location.hostname=='studio.myshuttle.io')?'https://gateway.myshuttle.io/prod/':'https://gateway-dev.myshuttle.io/',


      zoom_auth_dev_uri: 'https://zoom.us/oauth/authorize?response_type=code&client_id=IMTvIjspTiWQH1DyG6XM1Q',
      zoom_auth_prod_uri: 'https://zoom.us/oauth/authorize?response_type=code&client_id=DqPe17m1Q8yeHF7IGuws5g',
      zoom_dev_redirect_uri: 'https://gateway-dev.myshuttle.io/auth/zoom',
      zoom_prod_redirect_uri: 'https://gateway.myshuttle.io/prod/auth/zoom',



        auth_base_uri:'https://auth.myshuttle.io/login?client_id=j69k98muh523rpj8v790pe5pn&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=',
        //auth_redirect_uri:'http://localhost:8080',
        auth_redirect_uri:'https://studio.myshuttle.io',
        signed_uri:'https://gateway.myshuttle.io/prod/upload/getsignedurl',
        //h5p_json_default:'https://studio.myshuttle.io/h5p/base/h5p.json',
        h5p_json_default:'/h5p/base/h5p.json',
        h5p_library:'/h5p/core/libraries'


  		},
  		default_context_json:{
                          "interactiveVideo": {
                            "video": {
                              "startScreenOptions": {
                                "title": "Title",
                                "hideStartTitle": false,
                                "shortStartDescription": "Description"
                              },
                              "textTracks": {},
                              "files": [{
                                "path": "",
                                "mime": "video\/mp4",
                                "copyright": {
                                  "license": "U"
                                },
                                "metadata": {
                                  "qualityName": "Standard"
                                }
                              }]
                            },
                            "assets": {
                              "interactions": [],
                              "bookmarks": [],
                              "endscreens": []
                            },
                            "summary": {

                            }
                          },
                          "override": {
                            "autoplay": false,
                            "loop": false,
                            "showBookmarksmenuOnLoad": false,
                            "showRewind10": true,
                            "preventSkipping": false,
                            "deactivateSound": false,
                            "showPlaybackRate": false,
                            "startVideoAt": 0,
                            "completion": {
                                        "id": "shuttle.video.immediate"
                              }
                          }
                        },

  	endpoint: {

  			post_customer:'customer',
  			post_transcribe:'transcribe',
  			post_transcribe_status:'transcribe/job-status',
  			post_transcribe_update:'transcribe/modify',
        post_nlp: 'nlp/model',
        post_transcribe_start:'transcribe/start',
        post_upload_zoom: 'upload/upload-zoom-recording'

  	},

    runningProcesses: [],
    alertNotices: [],

  	auth:{},

  	dynamo:{},

    dynamoQuiz:{},

  	hashtokens:{},

  	currentShuttle:{},

    currentQuiz:{},

    search:'',

    H5P:{
      isDomReady:false,
      isVideoReady:false
    },

    currentEditTab:'video_options',
    currentSearchTerm:'',

    observeTranscribe: {},

    editor_layout: 'right',

    loader_overlay: false,
    overlay_loading_message: '',


    transcriptEdit:{
          transcript_segment_end:0,
          transcript_video_object:Object,
          listenmode:'transcript'
    }




  },





  mutations: {
      transcriptEdit(state, val) {
        state.transcriptEdit = val;
      },
      overlayLoadingState(state, val) {
        state.loader_overlay = true;
        state.overlay_loading_message = val;
      },

      removeOverlay(state) {
        state.loader_overlay = false;
        state.overlay_loading_message = '';
      },

      setEditorLayout(state, val) {
        state.editor_layout = val;
      },

      global_message(state, val){

          state.global_message = val;
      },

      packageready(state,val){
          state.currentShuttle.packageready = val;

      },


      currentEditTab(state,val){

          state.currentEditTab = val;
      },

    currentSearchTerm(state,val){

          state.currentSearchTerm = val;
      },

  		help(state,val){

  			state.help = val;
  		},


      H5P(state,val){

          state.H5P = val;
      },


      currentShuttlePackage(state,val){

        state.currentShuttle.package = val;

      },


      currentShuttleDuration(state,val){

        state.currentShuttle.duration = val;

      },

      currentShuttleTextInteractions(state,val){
          state.currentShuttle.textInteractions = val;

      },



      currentShuttleQuizInteractions(state,val){

        state.currentShuttle.quizInteractions = val;
      },

      currentShuttleCompletion(state,val){
          state.currentShuttle.completion = val;

      },

      currentShuttleBookmarks(state,val){
          state.currentShuttle.bookmarks = val;

      },

      currentShuttle_video_poster_image (state,val){
          state.currentShuttle.video_poster_image  = val;

      },

      currentShuttle_video_autoplay(state,val){
          state.currentShuttle.video_autoplay = val;

      },

      currentShuttle_video_loop(state,val){
          state.currentShuttle.video_loop = val;

      },

      currentShuttle_video_hide_transcript(state, val) {
        state.currentShuttle.hideTranscript = val;
      },

      currentShuttle_video_default_wide(state, val) {
        state.currentShuttle.videoDefaultWide = val;
      },

      currentShuttle_video_start_at(state,val){
          state.currentShuttle.video_start_at = val;

      },

      currentShuttle_video_show_playback_rate(state,val) {
        state.currentShuttle.showPlaybackRate = val;
      },

      currentShuttle_enablePopup(state,val) {
        state.currentShuttle.enablePopup = val;
      },

      currentShuttle_popupHeader(state,val) {
        state.currentShuttle.popupHeader = val;
      },

      currentShuttle_popupText(state,val) {
        state.currentShuttle.popupText = val;
      },

      currentShuttle_popupOccurrences(state,val) {
        state.currentShuttle.popupOccurrences = val;
      },

      currentShuttle_popupHr(state,val) {
        state.currentShuttle.popupHr = val;
      },

      currentShuttle_popupMin(state,val) {
        state.currentShuttle.popupMin = val;
      },

      currentShuttle_popupSec(state,val) {
        state.currentShuttle.popupSec = val;
      },

      currentShuttle_learner_email_questions(state,val) {
        state.currentShuttle.emailQuestions = val;
      },

      currentShuttle_video_learner_notes(state,val) {
        state.currentShuttle.showLearnerNotes = val;
      },

      currentShuttle_admin_email(state,val) {
        state.currentShuttle.adminEmail = val;
      },

      currentShuttle_addons(state, val) {
        state.currentShuttle.addons = val;
      },

      currentShuttle_video_bookmarks_open(state,val){
          state.currentShuttle.video_bookmarks_open = val;

      },

      currentShuttle_video_rewind_10(state,val){
          state.currentShuttle.video_rewind_10 = val;

      },

      currentShuttle_video_prevent_skipping(state,val){
          state.currentShuttle.video_prevent_skipping = val;

      },

      currentShuttleH5PContent(state,val){
          state.currentShuttle.H5PContent = val;

      },

      currentShuttleVideoTime(state,val){
          state.currentShuttle.videoTime = val;

      },

  		currentShuttleSpeakers(state,val){
  			state.currentShuttle.speakers = val;
  		},

  		currentShuttleVideo(state,val){
  			////console.log('current shuttle updated');
  			state.currentShuttle.video = val.video;
  			state.currentShuttle.video_status = val.video_status;
      },

      currentShuttleUserVideoURL(state, val) {
        state.currentShuttle.userVideoURL = val.video;
        state.currentShuttle.video = val.video;
        state.currentShuttle.video_status = val.video_status;
        state.currentShuttle.external_video = val.external_video;
      },

      currentShuttleZoomVideo(state, val) {
        state.currentShuttle.zoomVideoURL = val.video;
        state.currentShuttle.zoomStatus = val.status;
      },

      currentShuttleZoomUploadJob(state, val) {
        state.currentShuttle.zoomUploadJob = val;
      },

  		currentShuttleVideoOptions(state,val){
  			////console.log('current shuttle updated');
  			state.currentShuttle.title = val.title;
  			state.currentShuttle.description = val.description;
  		},
  		currentShuttleTranscribe(state,val){
  			////console.log('current shuttle updated');
  			state.currentShuttle.transcribe = val;

  		},

      currentShuttleTranscribeJob(state,val){
        ////console.log('current shuttle updated');
        state.currentShuttle.transcribejob = val;

      },

  		 currentShuttleTranscriptPath(state,val){
  			////console.log('current shuttle updated');
  			state.currentShuttle.transcriptPath = val;

  		},

      currentShuttleVTTPath(state,val){
        ////console.log('current shuttle updated');
        state.currentShuttle.vttPath = val;

      },

      currentShuttleCreationDate(state,val) {
        state.currentShuttle.createdOn = val;
      },


      currentShuttleArchive(state,val) {
        state.currentShuttle.archive = val;
      },




  		currentShuttle(state,val){
  			////console.log('current shuttle updated');
        //console.log('current shuttle MUTATION CALLED: ')
        //console.log(val);
  			state.currentShuttle = val;
  		},
      currentShuttleSilent(state,val){
        //prevent mutation call to reset video (transcription)

        state.currentShuttle = val;
      },
  		drawerState(state,val){
  			state.drawer = val;
  		},

  		auth(state,val){

  			state.auth = val;
  		},

  		hashtokens(state,val){

  			state.hashtokens = val;
  		},

  		dynamo(state,val){

  			state.dynamo = val;
  		},
  		addShuttle(state,val){

  			if (!state.dynamo.shuttles){

  				state.dynamo.shuttles = []
  			}

  			state.dynamo.shuttles.push(val);

  		},
  		updateShuttles(state,val){
  				state.dynamo.shuttles = val;


  		},

     dynamoQuiz(state,val){

        state.dynamoQuiz = val;
      },
     dynamoQuiz(state,val){

        state.dynamoQuiz = val;
      },

     currentQuiz(state,val){

        state.currentQuiz = val;
      },


      /* Auth Mutations */

      setUserAuthCredentials(state, payload) {
        //state.user = payload;
        state.hashtokens = payload.hashtokens;
        state.auth = payload.auth;
      },

      removeUserAuthCredentials(state) {
        //state.user = null;
        state.hashtokens = null;
        state.auth = null;
      },


      addAlertNotice(state, alertmsg) {
        state.alertNotices.unshift(alertmsg);
      },


      setObserveTranscribe(state, payload) {
        state.observeTranscribe = payload;
        //console.log("observer trans", state.observeTranscribe);
      },


      /* named entities nlp */
      currentShuttleNE(state, val) {
        if (!state.currentShuttle.nlp) { state.currentShuttle.nlp = { NE: val }; }
        else { state.currentShuttle.nlp.NE = val; }
      },


  },

	getters: {
	  currentShuttle: state => {return state.currrentShuttle},





	},

  actions: {
      dynamo({ commit }, val){

        commit('dynamo', val)
      },

        currentShuttle ({ commit }, val) {

          ////console.log('current shuttle ACTION CALLED')
          ////console.log(val);
          commit('currentShuttle', val)
        },

        currentShuttleSilent ({ commit }, val) {

          ////console.log('current shuttle ACTION CALLED')
          ////console.log(val);
          commit('currentShuttleSilent', val)
        },
    /* Auth Actions */

    authenticateUser({ commit }, payload) {
      const authenticationDetails = new AuthenticationDetails({
        Username: payload.username,
        Password: payload.password
      });

      const userPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });

      const cognitoUser = new CognitoUser({
        Username: payload.username,
      	Pool: userPool
      });

      return new Promise((resolve, reject) => cognitoUser.authenticateUser(authenticationDetails, {
          onFailure: (err) => {
            ////console.log(err);
            reject(err);
          },
          onSuccess: (session, userConfirmationNecessary) => {
            ////console.log("Session User Cognito data");
            ////console.log(session);
            commit('setUserAuthCredentials', constructUserCredentials(cognitoUser, session));

            resolve();
          }
        }));
    },


    // Only for authenticated users
    signOut({ commit, state }) {
      const userPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });

      return new Promise((resolve, reject) => {
        // Make sure the user is authenticated
        if (state.user === null || (state.user && state.user.tokens === null)) {
          reject({
            message: 'User is unauthenticated',
          });
          return;
        }

        const cognitoUser = new CognitoUser({
          Pool: userPool,
          Username: state.auth.username
        });

        cognitoUser.signOut();
        commit('removeUserAuthCredentials');
        resolve();
      });
    },



    signUp({ commit }, userInfo) {
      const cognitoUserPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });
      /* userInfo: { username, password, attributes } */
      const userAttributes = Object.keys(userInfo.attributes || {}).map(key => new CognitoUserAttribute({
        Name: key,
        Value: userInfo.attributes[key],
      }));

      return new Promise((resolve, reject) => {
        cognitoUserPool.signUp(
          userInfo.username, userInfo.password, userAttributes, null,
          (err, data) => {
            if (!err) {
              //console.log("SIGNUP SUCCESS"); //console.log(data);
              commit('setUserAuthCredentials', {
                auth: data.user,
                hashtokens: null, // no session yet
                attributes: {},
              });
              resolve({ userConfirmationNecessary: !data.userConfirmed });
              return;
            }
            //console.log("SIGNUP REJECT");
            //console.log(err);
            reject(err);
          });
      });
    },


    confirmRegistration({ state }, payload) {
      const cognitoUserPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });
      const cognitoUser = new CognitoUser({
        Pool: cognitoUserPool,
        Username: payload.username,
      });

      return new Promise((resolve, reject) => {
        cognitoUser.confirmRegistration(payload.code, true, (err) => {
          if (!err) {
            resolve();
            return;
          }
          reject(err);
        });
      });
    },

    resendConfirmationCode({ commit }, payload) {
      const cognitoUserPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });
      const cognitoUser = new CognitoUser({
        Pool: cognitoUserPool,
        Username: payload.username,
      });

      return new Promise((resolve, reject) => {
        cognitoUser.resendConfirmationCode(
          (err) => {
            if (!err) {
              resolve();
              return;
            }
            reject(err);
          });
      });
    },



    forgotPassword({ commit }, payload) {
      const cognitoUserPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });
      const cognitoUser = new CognitoUser({
        Pool: cognitoUserPool,
        Username: payload.username,
      });

      return new Promise((resolve, reject) => cognitoUser.forgotPassword({
        onSuccess() {
          resolve();
        },
        onFailure(err) {
          reject(err);
        },
      }));
    },


    confirmPassword({ commit }, payload) {
      const cognitoUserPool = new CognitoUserPool({
        UserPoolId: 'us-east-2_syU8UalN3',
        ClientId: 'j69k98muh523rpj8v790pe5pn'
      });
      const cognitoUser = new CognitoUser({
        Pool: cognitoUserPool,
        Username: payload.username,
      });

      return new Promise((resolve, reject) => {
        cognitoUser.confirmPassword(payload.code, payload.newPassword, {
          onFailure(err) {
            reject(err);
          },
          onSuccess() {
            resolve();
          },
        });
      });
    },







    addNewProcess({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('addAlertNotice', { msg: payload.startAlertMsg, timestamp: new Date() });
        setTimeout(() => {
          commit('addAlertNotice', { msg: payload.endAlertMsg, timestamp: new Date() });
          resolve();
        }, 5000)
      });
    },












  },
  modules: {
  },
  plugins: [createPersistedState({storage: window.sessionStorage})]

})
